import { render, staticRenderFns } from "./OilFuchsProd.vue?vue&type=template&id=d5285696&"
import script from "./OilFuchsProd.vue?vue&type=script&lang=js&"
export * from "./OilFuchsProd.vue?vue&type=script&lang=js&"
import style0 from "./OilFuchsProd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports